import { render, staticRenderFns } from "./SavedSearchLabel.vue?vue&type=template&id=90ac7576&"
import script from "./SavedSearchLabel.vue?vue&type=script&lang=ts&"
export * from "./SavedSearchLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports